export default {
  props: {
    firstBlock: {
      type: Object,
      required: true,
    },
    secondBlock: {
      type: Object,
      required: true,
    },
  },
}
